import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import RegionsDetailsForm from '../RegionsDetailsForm';
import ActionButton from '~components/atoms/ActionButton';

import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_regionsDetailsModal.module.scss';
import { TEditRegionDetailsReduxParams } from '~types/feat/branch';

const RegionsDetailsModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.branch.modals.regionDetailsModalIsOpen);
    const isEditing = useAppSelector(state => state.branch.modals.regionIsEditing);
    const isLoading = useAppSelector(state => state.branch.loadings.editRegionDetails);
    const editBranchDetailsError = useAppSelector(state => state.branch.errors.editRegionDetails);
    const regionDetails = useAppSelector(state => state.branch.selectedRegion);

    const userAccess = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = !!userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.CustomerManagement);

    if (!regionDetails) return null;

    const setIsEditing = (isEditMode: boolean) => dispatch(combinedActions.branchSetRegionDetailsModalIsEditing(isEditMode));

    const handleModalOnClose = () => {
        setIsEditing(false);
        dispatch(combinedActions.branchResetEditRegionDetailsState());
        dispatch(combinedActions.branchSetRegionDetailsModalIsOpen(false));
    };

    const handleOnSubmit = (data: TEditRegionDetailsReduxParams) => isEditing && dispatch(combinedActions.branchEditRegionDetailsAttempt(data));

    return (
        <Modal
            title='Region Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <div className={Styles.subcontainer}>
                {hasEditAccess
                    && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ActionButton
                                label={isEditing ? 'Disable editing' : 'Enable editing'}
                                onClick={() => setIsEditing(!isEditing)}
                            />
                        </div>
                    )
                }

                <RegionsDetailsForm
                    submitButtonLabel='Update'
                    actionButtonIsLoading={isLoading}
                    actionButtonClassName={Styles['form-action-button-disabled']}
                    actionButtonIsDisabled={!isEditing}
                    onSubmit={handleOnSubmit}
                    inputIsDisabled={!isEditing}
                    error={editBranchDetailsError}
                    isEditing={isEditing}
                    initialRegionDetails={regionDetails}
                />
            </div>
        </Modal>
    );
};

export default RegionsDetailsModal;
